import styled from 'styled-components';

export const Table = styled.table`
  border: 1px solid #c0c2c6;
  width: 100%;
  padding: 0;
  border-spacing: 0;
  margin-bottom: 20px;

  thead {
    tr {
      background: #f4f0ef;

      th {
        padding: 20px;
        text-align: left;
        border-top: 1px solid #c0c2c6;
        border-bottom: 1px solid #c0c2c6;
      }
    }

    &:first-child {
      tr th {
        border-top: none;
      }
    }

    &:last-child {
      tr th {
        border-bottom: none;
      }
    }
  }

  tbody {
    tr {
      &:nth-child(even) {
        background: #fcfafa;
      }

      &:nth-child(odd) {
        background: #fff;
      }

      td {
        padding: 10px 20px;
        text-align: left;
        height: 100px;
        vertical-align: top;
        font-size: 16px;
        line-height: 26px;
        color: #2d3540;
        border-bottom: 1px solid #c0c2c6;

        &:nth-child(1) {
          font-weight: bold;
        }
      }
      &:last-child {
        td {
          border-bottom: none;
        }
      }
    }
  }
`;
